import axios from 'axios';

export default {
    fetch() {
        return axios.get(window.API_BASE + '/my-whitelabel-configuration');
    },

    update(params) {
        return axios.put(window.API_BASE + '/my-whitelabel-configuration', params);
    }
}